import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { ModalDialogResult } from '../../models/modal-dialog-result';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisitorRegistrationFormType } from '../../models/visitor-registration-form-type';

@Component({
  selector: 'app-create-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    ReactiveFormsModule,
  ],
  templateUrl: './create-form-modal.component.html',
  styleUrl: './create-form-modal.component.scss'
})
export class CreateFormModalComponent {
  @Input() title: string = 'New Visitor Registration Form';

  model: any = {};
  form = new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'formType',
      type: 'radio',
      props: {
        label: 'What is the purpose of the visit?',
        placeholder: 'Placeholder',
        description: 'How long do you expect to stay at the site?',
        required: true,
        options: [
          { value: VisitorRegistrationFormType.BusinessTrip, label: 'I will only visit for a few days' },
          { value: VisitorRegistrationFormType.WorkOnSite, label: 'I will be working on site' },
        ],
      },
    }
  ];


  public onClose: Subject<ModalDialogResult<VisitorRegistrationFormType>> = new Subject();

  constructor(public activeModal: NgbActiveModal) {
  }

  cancel() {
    this.onClose.next({ result: false });
    this.activeModal.dismiss();
  }

  save() {
    this.onClose.next({ result: true, entity: this.model.formType });
    this.activeModal.dismiss();
  }
}
